import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, ButtonList, DropdownButton, Page, SearchInput, SimplePagination, Table, } from '@dixa/lib-shared-habla';
import { useEffect } from 'react';
import { useSetState } from 'react-use';
import { ConfirmModal } from 'components/shared/confirmModal/components/confirmModal';
import { TableLoadingRow } from 'components/shared/tableLoadingRow';
import { withTeamAgents } from 'hocs';
import { useNotifications } from 'hooks/useNotifications';
import { AgentsAddModal } from '../../../../shared/agentsAddModal';
import { TeamsAgentsTableRow } from './teamsAgentsTableRow';
const FETCH_DELAY = 1000;
const NUMBER_OF_COLUMNS = 3;
export const TeamsAgentsImpl = (props) => {
    var _a;
    const [state, setState] = useSetState({
        isConfirmModalOpen: false,
        isCreateModalOpen: false,
        waitingForFetch: false,
    });
    const notify = useNotifications();
    useEffect(() => {
        props.teamAgents.getItems();
    }, []);
    const setWaitingForFetch = (waitingForFetch) => {
        setState({
            waitingForFetch,
        });
    };
    const delayedFetchItems = () => {
        const { teamAgents } = props;
        const { getItems } = teamAgents;
        setTimeout(() => {
            getItems().then(() => {
                setWaitingForFetch(false);
            });
        }, FETCH_DELAY);
    };
    const handleSearchSubmit = (searchTerm) => {
        props.teamAgents.searchTermChange(searchTerm, 0);
    };
    const handleSearchToggle = (isOpen) => {
        if (!isOpen && props.teamAgents.searchTerm) {
            props.teamAgents.searchTermChange('', 0);
        }
    };
    const handleSortByNameAsc = () => {
        props.teamAgents.sortByChange('display_name', 'asc');
    };
    const handleSortByNameDesc = () => {
        props.teamAgents.sortByChange('display_name', 'desc');
    };
    const gotoNextPage = () => {
        props.teamAgents.nextPage();
    };
    const gotoPreviousPage = () => {
        props.teamAgents.previousPage();
    };
    const showRemoveModal = (agent) => {
        setState({ isConfirmModalOpen: true, currentAgent: agent });
    };
    const hideRemoveModal = () => {
        setState({ isConfirmModalOpen: false });
    };
    const handleDeleteTeam = () => {
        const { teamAgents } = props;
        const { currentAgent } = state;
        if (currentAgent) {
            setWaitingForFetch(true);
            teamAgents
                .remove([currentAgent.id])
                .then((r) => {
                setState({ isConfirmModalOpen: false });
                const notificationOptions = {
                    title: 'Agent removed',
                    text: `"${currentAgent.name}" agent has been removed from the team`,
                    icon: 'i-done',
                    className: 'success',
                    time: 5000,
                };
                notify(notificationOptions);
                delayedFetchItems();
            })
                .catch((e) => {
                const notificationOptions = {
                    title: 'An error occurred',
                    text: `An error occurred when trying to remove "${currentAgent.name}" agent from team`,
                    icon: 'i-exclamation',
                    className: 'danger',
                };
                notify(notificationOptions);
                setWaitingForFetch(false);
                console.error('Delete error', e);
            });
        }
    };
    const showCreateModal = () => {
        setState({ isCreateModalOpen: true });
    };
    const handleCreateModalClose = (canceled = false) => {
        setState({ isCreateModalOpen: false });
        if (!canceled) {
            setWaitingForFetch(true);
            delayedFetchItems();
        }
    };
    const handleRetry = () => {
        props.teamAgents.getItems();
    };
    const renderLoadingStatus = () => {
        const { teamAgents } = props;
        if (teamAgents.getItemsAsyncStatus === 'failed') {
            return (_jsx(Table.Tr, { children: _jsxs(Table.Td, Object.assign({ colSpan: NUMBER_OF_COLUMNS }, { children: ["Something went wrong...", _jsx(Button, Object.assign({ variant: "tertiary", onClick: handleRetry }, { children: "Retry" }))] })) }));
        }
        return _jsx(TableLoadingRow, { colSpan: 2 });
    };
    const renderSuccessStatus = () => {
        const { teamAgents } = props;
        const { items } = teamAgents;
        let success;
        if (items.length > 0) {
            success = items.map((teamAgent, i) => (_jsx(TeamsAgentsTableRow, { teamAgent: teamAgent, showRemoveModal: showRemoveModal }, i)));
        }
        else {
            success = (_jsx(Table.Tr, { children: _jsx(Table.Td, Object.assign({ colSpan: NUMBER_OF_COLUMNS }, { children: "No agents found." })) }));
        }
        return success;
    };
    const renderFoot = () => {
        const { teamAgents } = props;
        const { hasNextPage, hasPreviousPage, getItemsAsyncStatus } = teamAgents;
        const foot = (_jsx(Table.Tfoot, { children: _jsx(Table.Tr, { children: _jsx(Table.Td, Object.assign({ colSpan: NUMBER_OF_COLUMNS }, { children: _jsx(SimplePagination, { previousButtonClick: gotoPreviousPage, previousButtonDisabled: !hasPreviousPage, nextButtonClick: gotoNextPage, nextButtonDisabled: !hasNextPage, loading: getItemsAsyncStatus === 'loading' }) })) }) }));
        return foot;
    };
    const { teamAgents, teamId } = props;
    const { hasNextPage, hasPreviousPage, getItemsAsyncStatus, searchTerm } = teamAgents;
    const { waitingForFetch } = state;
    const showFoot = hasNextPage || hasPreviousPage;
    return (_jsxs(_Fragment, { children: [_jsx(Page.Section, Object.assign({ title: "All agents", controls: _jsxs(_Fragment, { children: [_jsx(SearchInput, { onSubmit: handleSearchSubmit, onToggle: handleSearchToggle }), _jsx(DropdownButton, Object.assign({ buttonProps: { disabled: !!searchTerm.length }, dropdown: _jsxs(ButtonList, { children: [_jsx(ButtonList.Item, Object.assign({ icon: "arrow-up", onClick: handleSortByNameAsc }, { children: "A - Z" })), _jsx(ButtonList.Item, Object.assign({ icon: "arrow-down", onClick: handleSortByNameDesc }, { children: "Z - A" }))] }) }, { children: "Sort by" })), _jsx(Button, Object.assign({ onClick: showCreateModal }, { children: "Add agents" }))] }) }, { children: _jsxs(Table, Object.assign({ framed: true, stickyHeader: true, stickyFooter: true, headerWithBackground: true }, { children: [_jsx(Table.Thead, { children: _jsxs(Table.Tr, { children: [_jsx(Table.Th, { children: "Agent" }), _jsx(Table.Th, { children: "Email" }), _jsx(Table.Th, { width: "0" })] }) }), _jsx(Table.Tbody, { children: !waitingForFetch && getItemsAsyncStatus === 'succeeded'
                                ? renderSuccessStatus()
                                : renderLoadingStatus() }), showFoot && renderFoot()] })) })), _jsx(ConfirmModal, { isShown: state.isConfirmModalOpen, headline: "Are you sure?", text: `Are you sure you want to remove "${(_a = state.currentAgent) === null || _a === void 0 ? void 0 : _a.name}" agent from the team?`, confirmText: "Yes, delete it now", cancelText: "Cancel", confirm: handleDeleteTeam, cancel: hideRemoveModal }), _jsx(AgentsAddModal, { isOpen: state.isCreateModalOpen, onClose: handleCreateModalClose, addAgents: teamAgents.add, parentEntity: "team", teamId: teamId })] }));
};
export const TeamsAgents = withTeamAgents(TeamsAgentsImpl);
